var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.85002 9.9999C1.85002 5.49878 5.4989 1.8499 10 1.8499C14.5011 1.8499 18.15 5.49878 18.15 9.9999C18.15 14.501 14.5011 18.1499 10 18.1499C5.4989 18.1499 1.85002 14.501 1.85002 9.9999ZM10 0.149902C4.56002 0.149902 0.150024 4.5599 0.150024 9.9999C0.150024 15.4399 4.56002 19.8499 10 19.8499C15.44 19.8499 19.85 15.4399 19.85 9.9999C19.85 4.5599 15.44 0.149902 10 0.149902ZM9.15002 9.99991C9.15002 10.4694 9.53058 10.8499 10 10.8499C10.4695 10.8499 10.85 10.4694 10.85 9.99991V5.99991C10.85 5.53047 10.4695 5.14991 10 5.14991C9.53058 5.14991 9.15002 5.53047 9.15002 5.99991V9.99991ZM10 12.3499C9.36491 12.3499 8.85004 12.8648 8.85004 13.4999C8.85004 14.135 9.36491 14.6499 10 14.6499C10.6352 14.6499 11.15 14.135 11.15 13.4999C11.15 12.8648 10.6352 12.3499 10 12.3499Z",
    fill: "#11294C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.9ee8f57e6cbcf3db5f064dae21bb71c6.svg";
export { ForwardRef as ReactComponent };